import ReactPDF, { Text, View } from "@react-pdf/renderer";
import { formatCurrency } from "../../../../utils/Format";
import { handlingCost, hfInformationCost, informationCost, totalCost } from "../../../../utils/Cost";
import * as React from "react";
import { OrderCategory, TOrderCostV1 } from "../../../../api/endpoints/Order";

interface IProps {
  styles: ReactPDF.Styles;
  cost: TOrderCostV1;
  orderCategory: OrderCategory;
  annualTotalCostFootnoteRef?: string;
}

const OrderCostSummaryPdfV1 = (props: IProps) => {
  const { cost, orderCategory, styles, annualTotalCostFootnoteRef = '' } = props;

  if (!cost.data.total_cost) {
    return null;
  }

  return (
    <View>
      {
        orderCategory !== 'archive' &&
        <View style={styles.footer}>
          <View style={styles.footerTitles}>
            <Text>Annual Information Cost</Text>
          </View>

          <View style={styles.footerCosts}>
            <Text>
              {
                formatCurrency(informationCost(cost))
              }
            </Text>
          </View>
        </View>
      }

      {
        (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT) &&
        <View style={styles.footer}>
          <View style={styles.footerTitles}>
            <Text>Annual High Frequency Products Information Cost</Text>
          </View>

          <View style={styles.footerCosts}>
            <Text>
              {
                formatCurrency(hfInformationCost(cost))
              }
            </Text>
          </View>
        </View>
      }

      <View style={styles.footer}>
        <View style={styles.footerTitles}>
          <Text>Annual ECMWF handling charge</Text>
        </View>

        <View style={styles.footerCosts}>
          <Text>
            {
              formatCurrency(handlingCost(cost))
            }
          </Text>
        </View>
      </View>

      <View style={styles.footerHighlight}>
        <View style={styles.footerTitles}>
          <Text>Annual total cost{annualTotalCostFootnoteRef}</Text>
        </View>

        <View style={styles.footerCosts}>
          <Text>
            {formatCurrency(totalCost(cost))}
          </Text>
        </View>
      </View>
    </View>
  )
}

export default OrderCostSummaryPdfV1;
